import { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  GetAllBussinessAddressesListPayloadType,
  GetAllLedgersListPayloadType,
  GetSingleCustomerSupplierListPayloadType,
} from "../../../commonTypes/clientSettingsTypes";
import {
  CommonHeader,
  EmptyListPage,
  Loader,
  ErrorSuccessModal,
} from "../../../components/commons";
import { LedgerStatementImage } from "../../../assets/images";
import {
  getAllBusinessAddressAction,
  getAllTypesWithTaxListAction,
  getSingleCustomerSupplierAction,
  resetAllLedgersList,
  resetAllTypesLedgerListWithTaxList,
  resetBusinessAddressList,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetSingleCustomerSupplier,
} from "../../../redux/clientSettings";
import { RootState } from "../../../redux/rootReducers";
import LedgerStatementHeader from "../../../components/Reports/LedgerStatement/LedgerStatementHeader";
import {
  AllLedgersListType,
  BusinessAddressListType,
  CustomerSupplierListType,
} from "../../../redux/clientSettings/clientSettingTypes";
import {
  getLedgerStatementAction,
  resetLedgerStatement,
  resetReportsError,
  resetReportsFetching,
  resetReportsSuccess,
  resetTaxLedgerStatementCount,
} from "../../../redux/reports";
import {
  DownloadExcelReportsType,
  GetLedgerStatementType,
} from "../../../commonTypes/reportsTypes";
import {
  LedgerStatementType,
  TotalDebitCreditAmountType,
} from "../../../redux/reports/reportsType";
import LedgerStatementTable from "../../../components/Reports/LedgerStatement/LedgerStatementTable/LedgerStatementTable";
import { formatDate, handleDate } from "../../../utils/commonFunctions";
import moment from "moment";
import FileSaver from "file-saver";
import { downloadReportsApi } from "../../../apis/reportsApis";
import { Excel } from "../../../components/Icon";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { toast, Toaster } from "react-hot-toast";
import ViewEditCustomerSuplierModal from "../../../components/Reports/LedgerStatement/ViewEditCustomerSuplierModal";
import SkeltonElement from "../../../components/commons/SkeltonLoader/SkeltonElement";
import { useLocation } from "react-router-dom";

export type BranchListType = {
  value: number | string;
  label: string;
};
export type FilterMultiSelectDataType = {
  invoiceType: { label: string; value: number | null };
  transactionAmountType: { label: string; value: string | null };
  transactionAmountLimitType?: { label: string; value: string | null } | undefined;
  value: string;
};
type AppProps = {
  token: string | null;
  ledgerListFetching: boolean;
  customerSuplierFetching: boolean;
  history?: any;
  dispatchGetAllTypesLedgerListAction: (
    data: GetAllLedgersListPayloadType
  ) => void;
  dispatchResetClientSettingsError: () => void;
  dispatchResetResetClientSettingSuccess: () => void;
  dispatchResetReportsErrorAction: () => void;
  dispatchResetReportsSuccessAction: () => void;
  dispatchResetLedgerStatement: () => void;
  dispatchResetSingleCustomerSupplier: () => void;
  dispatchGetLedgerStatement: (data: GetLedgerStatementType) => void;
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => void;
  dispatchResetSession: () => void;
  dispatchResetTaxLedgerStatementCount: () => void;
  dispatchResetAllLeagerList: () => void;
  dispatchResetReportsFetchingAction: () => void;
  dispatchGetAllBusinessAddressList: (
    data: GetAllBussinessAddressesListPayloadType
  ) => void;
  dispatchResetBusinessAddressList: () => void;
  allTypesLedgersList: [] | AllLedgersListType[];
  reportsFetching: boolean;
  reportsError: string | null;
  currencySign: string | undefined;
  customerSupplierMessage: string | null;
  reportsSuccess: number | null;
  reportsStatusCode: number | null;
  ledgerStatement: [] | LedgerStatementType[];
  ledgerStatementCount: number;
  singleCustomerSupplier: CustomerSupplierListType;
  closingBalance: number;
  openingBalance: number;
  totalDebitCreditAmount: TotalDebitCreditAmountType;
  businessAddressList: [] | BusinessAddressListType[];

};

const LedgerStatement = ({
  history,
  token,
  currencySign,
  allTypesLedgersList,
  ledgerListFetching,
  reportsFetching,
  customerSuplierFetching,
  reportsError,
  reportsSuccess,
  reportsStatusCode,
  ledgerStatement,
  ledgerStatementCount,
  dispatchGetAllTypesLedgerListAction,
  dispatchResetClientSettingsError,
  dispatchResetAllLeagerList,
  dispatchResetResetClientSettingSuccess,
  dispatchGetLedgerStatement,
  dispatchResetLedgerStatement,
  dispatchResetSession,
  dispatchResetReportsErrorAction,
  dispatchResetReportsSuccessAction,
  dispatchGetSingleCustomerSupplierAction,
  singleCustomerSupplier,
  dispatchResetSingleCustomerSupplier,
  customerSupplierMessage,
  dispatchResetTaxLedgerStatementCount,
  dispatchResetReportsFetchingAction,
  closingBalance,
  openingBalance,
  totalDebitCreditAmount,
  dispatchGetAllBusinessAddressList,
  dispatchResetBusinessAddressList,
  businessAddressList
}: AppProps) => {
  const search = useLocation().search;
  const clientCodeFromParams = new URLSearchParams(search).get("client_code");
  const companyNameFromParams = new URLSearchParams(search).get("company_name");

  const client_code: number = history?.location?.state?.client_code
    ? history?.location?.state?.client_code
    : clientCodeFromParams;
  const company_name: string = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : companyNameFromParams;
  const redirectedLedgerId = localStorage.getItem("ledger_id");
  const redirectedStartDate = localStorage.getItem("start_date");
  const redirectedEndDate = localStorage.getItem("end_date");
  const redirectBranchId = localStorage.getItem("branch_id");
  const redirectBranchName = localStorage.getItem("branchName");
  const [allLedgersList, setAllLedgersList] = useState<any[]>([]);
  const [ledgerName, setLedgerName] = useState<any>({
    value: null,
    label: "Select Ledger...",
  });
  const [ledgerId, setLedgerId] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [displayLedgerName, setDisplayLedgerName] = useState("");
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");
  const [ledgerStatementUpdate, setledgerStatementUpdate] = useState(false);
  const [showRedirectIcon, setShowRedirectIcon] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isEditCustomerSupplierPresent, setIsEditCustomerSupplierPresent] =
    useMenuCheck();
  const [redirectToCustomerSuplier, setRedirectToCustomerSuplier] =
    useState<boolean>(false);
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<any>([]);
  const [toggle, setToggle] = useState<boolean>(false);
  const [branchList, setBranchList] = useState<[] | BranchListType[]>([]);
  const [branchSelected, setBranchSelected] = useState<any>({
    value: "",
    label: "Select Branch...",
  });
  const [selectedBranchId, setSelectedBranchId] = useState<any>(null);
  const [branchName, setBranchName] = useState<string | null>("");

  const [filterToggle, setFilterToggle] = useState<boolean>(false);
  const [filterValue, setFilterValue] = useState<FilterMultiSelectDataType>({
    invoiceType: { label: "", value: null },
    transactionAmountType: { label: "", value: null },
    transactionAmountLimitType: { label: "", value: null },


    value: "",

  });

  const [multiSelectData, setMultiSelectData] =
    useState<FilterMultiSelectDataType>({
      invoiceType: { label: "", value: null },
      transactionAmountType: { label: "", value: null },
      transactionAmountLimitType: { label: "", value: null },

      value: ""
    });

  //========== User Management ==========//
  const [isExpensesPresnet, setIsExpensesPresent] = useMenuCheck();
  const [isRevenuPresent, setIsRevenuPresent] = useMenuCheck();
  const [isOthersPresent, setIsOthersPresent] = useMenuCheck();
  const [isDownloadLedgerPresent, setIsDownloadLedgerPresent] = useMenuCheck();
  //====================//
  useEffect(() => {
    setIsExpensesPresent("Edit Expense Invoicing Advanced", "menu");
    setIsRevenuPresent("Edit Sales Invoicing Advanced", "menu");
    setIsOthersPresent("Edit Others Invoicing Advanced", "menu");
    setIsDownloadLedgerPresent("Download Ledger Statement", "menu");
    setIsEditCustomerSupplierPresent("Edit Customer/Supplier", "menu");
    setBranchList([]);
    setBranchName("");
    dispatchResetClientSettingsError();
    dispatchResetAllLeagerList();
    dispatchResetResetClientSettingSuccess();
    dispatchResetLedgerStatement();
    dispatchResetReportsErrorAction();
    dispatchResetReportsSuccessAction();
    dispatchResetSingleCustomerSupplier();
    dispatchResetTaxLedgerStatementCount();
    dispatchResetReportsFetchingAction();
    dispatchResetBusinessAddressList();
    setData([]);
    if (token && client_code) {
      dispatchGetAllTypesLedgerListAction({ client_code, token });
      dispatchGetAllBusinessAddressList({ token, client_code });

    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (allTypesLedgersList && allTypesLedgersList?.length) {
      let finalLedgersList: any[] = [];
      allTypesLedgersList?.map((ledger: AllLedgersListType) => {
        finalLedgersList.push({
          value: ledger?.ledger_id,
          label: `${ledger?.ledger_name ? ledger?.ledger_name : ""} %${ledger?.trade_name ? ledger?.trade_name : ""
            }`,
        });
      });
      setAllLedgersList(finalLedgersList);
    }
  }, [allTypesLedgersList]);


  useEffect(() => {
    if (
      ledgerName.label !== displayLedgerName ||
      displayEndDate != endDate ||
      startDate != displayStartDate
    ) {
      setDisplayLedgerName(ledgerName.label);
      setDisplayStartDate(formatDate(startDate));
      setDisplayEndDate(formatDate(endDate));
    }
    branchSelected?.label !== "Select Branch..."
      ? setBranchName(branchSelected?.label)
      : setBranchName("");
    //eslint-disable-next-line
  }, [ledgerStatement]);

  useEffect(() => {
    if (businessAddressList && businessAddressList?.length > 0) {
      let finalBranchList: any[] = [];
      businessAddressList?.map((businessAddress: BusinessAddressListType) => {
        finalBranchList.push({
          value: businessAddress?.ledger_id,
          label: businessAddress?.trade_name,
        });
      });

      setBranchList(finalBranchList);
    }
  }, [businessAddressList]);

  // Calling only while redirection from different reports
  useEffect(() => {
    if (redirectedLedgerId !== undefined && allLedgersList?.length) {
      let finalRedirectLedger = allLedgersList?.filter(
        (id) => id?.value == redirectedLedgerId
      );
      setSelectedBranchId(redirectBranchId)
      setBranchName(redirectBranchName)
      if ((redirectBranchId && redirectBranchName) || (branchSelected)) {
        setBranchSelected({
          value: redirectBranchId || branchSelected?.value,
          label: redirectBranchName || branchSelected?.label
        })
      }
      else {
        setBranchSelected({
          value: "",
          label: "Select Branch...",
        })
      }

      if (finalRedirectLedger?.length > 0) {
        handleSetLedger(finalRedirectLedger[0]);
        handleStartDateChange(redirectedStartDate);
        handleEndDateChange(redirectedEndDate);
        let finalData = {
          ledger_id: finalRedirectLedger[0].value,
          start_date: formatDate(redirectedStartDate ?? ""),
          end_date: formatDate(redirectedEndDate ?? ""),
          client_code,
          token,
          limit,
          offset,
          branch_id: redirectBranchId || branchSelected?.value,
          invoice_type: filterValue?.invoiceType?.value ? filterValue?.invoiceType?.value : null,
          more_than_value: filterValue?.transactionAmountLimitType?.value === "more_than_value" ? filterValue?.value : "",
          less_than_value: filterValue?.transactionAmountLimitType?.value === "less_than_value" ? filterValue?.value : "",
          equal_to_value: filterValue?.transactionAmountLimitType?.value === "equal_to_value" ? filterValue?.value : "",
          transaction_type: filterValue?.transactionAmountType?.value ? filterValue?.transactionAmountType?.value : null,



        };
        setledgerStatementUpdate(true);
        if (startDate && endDate) {
          dispatchGetLedgerStatement(finalData);
        }
        handleResetData();
      }
    }
    if (redirectToCustomerSuplier) {
      const newLedgerName = allLedgersList?.filter(
        (e: any) => e.value === ledgerId
      );
      setLedgerName(newLedgerName[0]);
      if (startDate && endDate) {
        handleSubmitData();
        setRedirectToCustomerSuplier(false);
      }
    }
    //eslint-disable-next-line
  }, [redirectedLedgerId, allLedgersList]);

  useEffect(() => {

  }, [redirectedLedgerId])

  useEffect(() => {
    dispatchResetLedgerStatement();
    //eslint-disable-next-line
  }, [redirectedLedgerId]);

  useEffect(() => {
    if (ledgerStatement?.length === 0 && offset === 0) {
      setData([ledgerStatement]);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...ledgerStatement]);
    } else {
      setData([...ledgerStatement]);
    }
    //eslint-disable-next-line
  }, [ledgerStatement]);

  useEffect(() => {
    if (token && client_code && startDate && endDate) {
      let finalData: GetLedgerStatementType = {
        ledger_id: ledgerName.value,
        start_date: formatDate(startDate),
        end_date: formatDate(endDate),
        client_code,
        token,
        limit,
        offset,
        branch_id: selectedBranchId || branchSelected?.value,
        invoice_type: filterValue?.invoiceType?.value ? filterValue?.invoiceType?.value : null,
        more_than_value: filterValue?.transactionAmountLimitType?.value === "more_than_value" ? filterValue?.value : "",
        less_than_value: filterValue?.transactionAmountLimitType?.value === "less_than_value" ? filterValue?.value : "",
        equal_to_value: filterValue?.transactionAmountLimitType?.value === "equal_to_value" ? filterValue?.value : "",
        transaction_type: filterValue?.transactionAmountType?.value ? filterValue?.transactionAmountType?.value : null,



      };

      if (offset < +ledgerStatementCount) {
        dispatchGetLedgerStatement(finalData);
      } else if (ledgerStatementCount === 0 && offset === 0) {
        dispatchGetLedgerStatement(finalData);
      }
    }
    //eslint-disable-next-line
  }, [offset]);

  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight) {
      if (ledgerStatement?.length > 0) {
        setOffset(offset + limit);
      }
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    //eslint-disable-next-line
  }, [ledgerStatement]);

  const handleSetLedger = (ledgerDetail: any) => {
    setLedgerName({
      value: ledgerDetail.value,
      label: ledgerDetail?.label?.split("%")[0],
    });
    setLedgerId(ledgerDetail?.value);
  };

  const handleStartDateChange = (date: any) => {
    const value = handleDate(date);
    setStartDate(value);
  };

  const handleEndDateChange = (date: any) => {
    const value = handleDate(date);
    setEndDate(value);
  };

  const handleManageRedirectToInvoice = (invoiceType: number) => {
    if (invoiceType === 1 && isExpensesPresnet) {
      setShowRedirectIcon(true);
    } else if (invoiceType === 2 && isRevenuPresent) {
      setShowRedirectIcon(true);
    }
  };
  const handleResetData = () => {
    if (ledgerStatementUpdate) {
      localStorage.removeItem("start_date");
      localStorage.removeItem("end_date");
      localStorage.removeItem("ledger_id");
      localStorage.removeItem("branch_id")
      localStorage.removeItem("branchName")
    }
  };

  const handleBranchChange = (data: BranchListType) => {
    setSelectedBranchId(+data?.value);
    setBranchSelected(data);
  };
  const handleSubmitData = () => {
    dispatchResetLedgerStatement();
    window.scrollTo(0, 0);
    setData([]);
    if (offset === 0) {
      localStorage.removeItem("start_date");
      localStorage.removeItem("end_date");
      localStorage.removeItem("ledger_id");
      localStorage.removeItem("branch_id")
      localStorage.removeItem("branchName")
      let finalData: GetLedgerStatementType = {
        ledger_id: ledgerName.value,
        start_date: formatDate(startDate),
        end_date: formatDate(endDate),
        client_code,
        token,
        limit,
        offset,
        branch_id: selectedBranchId || branchSelected?.value,
        invoice_type: filterValue?.invoiceType?.value ? filterValue?.invoiceType?.value : null,
        transaction_type: filterValue?.transactionAmountType?.value ? filterValue?.transactionAmountType?.value : null,
        more_than_value: filterValue?.transactionAmountLimitType?.value === "more_than_value" ? filterValue?.value : "",
        less_than_value: filterValue?.transactionAmountLimitType?.value === "less_than_value" ? filterValue?.value : "",
        equal_to_value: filterValue?.transactionAmountLimitType?.value === "equal_to_value" ? filterValue?.value : "",



      };
      // if(offset===0){
      dispatchGetLedgerStatement(finalData);
      // }
    } else {
      setOffset(0);
    }
  };

  const handlePrepareDownload = () => {
    let params: DownloadExcelReportsType = {
      start_date: moment(startDate).format("DD-MM-YYYY"),
      end_date: moment(endDate).format("DD-MM-YYYY"),
      ledger_id: ledgerName.value,
      client_code: client_code,
      branch_id: selectedBranchId || branchSelected?.value,
      limit: 1000,
      offset: 0,
      token,
      invoice_type: filterValue?.invoiceType?.value ? filterValue?.invoiceType?.value : null,
      transaction_type: filterValue?.transactionAmountType?.value ? filterValue?.transactionAmountType?.value : null,
      more_than_value: filterValue?.transactionAmountLimitType?.value === "more_than_value" ? filterValue?.value : "",
      less_than_value: filterValue?.transactionAmountLimitType?.value === "less_than_value" ? filterValue?.value : "",
      equal_to_value: filterValue?.transactionAmountLimitType?.value === "equal_to_value" ? filterValue?.value : "",

    };

    if (params && token) {
      handleDownload(params);
    }
  };

  const handleDownload = (params: DownloadExcelReportsType) => {
    let reportName = company_name
      ? company_name +
      "-" +
      ledgerName.label +
      "_" +
      moment(startDate).format("DD-MM-YYYY") +
      " to " +
      moment(endDate).format("DD-MM-YYYY") +
      ".xlsx"
      : "report";
    downloadReportsApi(params).then((response: any) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };


  const handleApplyFilter = () => {
    dispatchResetLedgerStatement();
    window.scrollTo(0, 0);
    setData([]);
    setMultiSelectData({
      invoiceType: filterValue?.invoiceType,
      transactionAmountType: filterValue?.transactionAmountType,
      value: filterValue?.value,

    });

    if (offset === 0) {
      localStorage.removeItem("start_date");
      localStorage.removeItem("end_date");
      localStorage.removeItem("ledger_id");
      localStorage.removeItem("branch_id")
      localStorage.removeItem("branchName")
      let finalData: GetLedgerStatementType = {
        ledger_id: ledgerName.value,
        start_date: formatDate(startDate),
        end_date: formatDate(endDate),
        client_code,
        token,
        limit,
        offset,
        branch_id: selectedBranchId || branchSelected?.value,
        invoice_type: filterValue?.invoiceType?.value ? filterValue?.invoiceType?.value : null,
        more_than_value: filterValue?.transactionAmountLimitType?.value === "more_than_value" ? filterValue?.value : "",
        less_than_value: filterValue?.transactionAmountLimitType?.value === "less_than_value" ? filterValue?.value : "",
        equal_to_value: filterValue?.transactionAmountLimitType?.value === "equal_to_value" ? filterValue?.value : "",
        transaction_type: filterValue?.transactionAmountType?.value ? filterValue?.transactionAmountType?.value : null,



      };
      // if(offset===0){
      dispatchGetLedgerStatement(finalData);
      // }
    } else {
      setOffset(0);
    }


  };

  const handleFilterClear = () => {
    dispatchResetLedgerStatement();
    setFilterValue({
      invoiceType: { label: "", value: null },
      transactionAmountType: { label: "", value: null },
      transactionAmountLimitType: { label: "", value: null },


      value: ""
    });
    setMultiSelectData({
      invoiceType: { label: "", value: null },
      transactionAmountType: { label: "", value: null },

      value: "",
    });

    if (token) {
      let finalData: GetLedgerStatementType = {
        ledger_id: ledgerName.value,
        start_date: formatDate(startDate),
        end_date: formatDate(endDate),
        client_code,
        token,
        limit,
        offset,
        branch_id: selectedBranchId || branchSelected?.value,


      };
      // if(offset===0){
      dispatchGetLedgerStatement(finalData)
    }
  };

  const handleErrorModal = () => {
    if (reportsSuccess === 0) {
      if (reportsStatusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!reportsError}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={reportsStatusCode}
          />
        );
      } else if (!!reportsError && reportsStatusCode !== 401) {
        return (
          <ErrorSuccessModal
            type={
              !!reportsError && reportsError.includes("Invoice Ledger")
                ? "warning"
                : "error"
            }
            isOpen={!!reportsError}
            title={
              !!reportsError && reportsError.includes("Invoice Ledger")
                ? "Processing Statement"
                : "Error"
            }
            message={reportsError}
            buttonText="OK"
            onPress={() => {
              dispatchResetReportsErrorAction();
            }}
          />
        );
      }
    }

    return false;
  };
  const handleCustomerSuplierDetailsData = (data: number) => {
    setShowModal(!showModal);
    if (token && client_code) {
      const finaldata = {
        token,
        client_code,
        customerSupplierId: data,
      };
      dispatchGetSingleCustomerSupplierAction(finaldata);
    }
  };
  const handleCustomerSupliertoogle = () => {
    setShowModal(!showModal);
    if (redirectToCustomerSuplier) {
      if (token && client_code) {
        dispatchGetAllTypesLedgerListAction({ client_code, token });
      }
    }
  };

  const renderDownloadInvoiceToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        Download Excel
      </Tooltip>
    );
  };
  return (
    <>
      <div className="col-md-6">
        <CommonHeader
          title="Ledger Statement"
          company_name={company_name}
          client_code={client_code}
        />
      </div>
      <div className="report-card mt-4 pt-3">
        <div className="inside-report-card">
          <LedgerStatementHeader
            setToggle={setToggle}
            toggle={toggle}
            allLedgersList={allLedgersList}
            ledgerListFetching={ledgerListFetching}
            ledgerName={ledgerName}
            handleSetLedger={handleSetLedger}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            handleSubmitData={handleSubmitData}
            client_code={client_code}
            handlePrepareDownload={handlePrepareDownload}
            branchList={branchList}
            branchSelected={branchSelected}
            handleBranchChange={handleBranchChange}
            filterToggle={filterToggle}
            setFilterToggle={setFilterToggle}
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            handleApplyFilter={handleApplyFilter}
            handleFilterClear={handleFilterClear}
            multiSelectData={multiSelectData}
            ledgerStatement={ledgerStatement}
          />
          <hr className="mt-4 mb-4" />
          {data &&
            data?.length === 0 &&
            openingBalance == 0 &&
            !reportsFetching ? (
            <EmptyListPage
              title="No Statement Found!"
              text="Choose ledger name, start date and end date to get Ledger Statement."
              image={LedgerStatementImage}
              imageWidth="30%"
            />
          ) : (
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div></div>
                <h3
                  className={
                    isDownloadLedgerPresent ? "text-center ml-5" : "text-center"
                  }
                >
                  {displayLedgerName}

                </h3>

                <div className=" d-flex justify-content-end">
                  {isDownloadLedgerPresent && (
                    <div className="mt-1">
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 250 }}
                        overlay={renderDownloadInvoiceToolTip}
                      >
                        <button
                          style={{ border: "none", marginTop: "-12px" }}
                          onClick={handlePrepareDownload}
                          disabled={!ledgerName.value || !startDate || !endDate}
                        >
                          <Excel />
                        </button>
                      </OverlayTrigger>
                    </div>
                  )}
                </div>

              </div>
              <h5 className="text-center">{branchName && `Branch: ${branchName}`}</h5>

              <div className="d-flex justify-content-center mt-3">
                <h6 className="text-muted text-center mr-4">
                  Start Date:{" "}
                  {reportsFetching ? (
                    <span>
                      <SkeltonElement type="title" />
                    </span>
                  ) : (
                    <span className="font-weight-bolder">
                      {displayStartDate}
                    </span>
                  )}
                </h6>
                <h6 className="text-muted text-center">
                  End Date:{" "}
                  {reportsFetching ? (
                    <span>
                      <SkeltonElement type="title" />
                    </span>
                  ) : (
                    <span className="font-weight-bolder">{displayEndDate}</span>
                  )}
                </h6>
              </div>
              <LedgerStatementTable
                ledgerStatementData={data}
                reportsFetching={reportsFetching}
                client_code={client_code}
                company_name={company_name}
                handleManageRedirectToInvoice={handleManageRedirectToInvoice}
                handleCustomerSuplierDetailsData={
                  handleCustomerSuplierDetailsData
                }
                offset={offset}
                currencySign={currencySign ? currencySign : ""}
                closingBalance={closingBalance}
                openingBalance={openingBalance}
                totalDebitCreditAmount={totalDebitCreditAmount}
              />
            </>
          )}
        </div>
      </div>
      {showModal && (
        <ViewEditCustomerSuplierModal
          isOpen={showModal}
          setRedirectToCustomerSuplier={setRedirectToCustomerSuplier}
          fetching={customerSuplierFetching}
          client_code={client_code}
          company_name={company_name}
          isEditCustomerSupplierPresent={isEditCustomerSupplierPresent}
          toggle={handleCustomerSupliertoogle}
          singleCustomerSupplier={singleCustomerSupplier}
          currencySign={currencySign}
        />
      )}
      {ledgerListFetching && <Loader />}
      {handleErrorModal()}
      <Toaster />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  allTypesLedgersList: state.clientSettings.allTypesLedgersWithTaxList,
  ledgerListFetching: state.clientSettings.fetching,
  reportsFetching: state.reports.fetching,
  reportsError: state.reports.error,
  ledgerStatement: state.reports.ledgerStatement,
  ledgerStatementCount: state.reports.ledgerStatementCount,
  reportsSuccess: state.reports.success,
  reportsStatusCode: state.reports.statusCode,
  singleCustomerSupplier: state.clientSettings.singleCustomerSupplier,
  customerSuplierFetching: state.clientSettings.fetching,
  customerSupplierMessage: state.clientSettings.customerSupplierMessage,
  currencySign: state.auth.currencySign,
  closingBalance: state.reports.closingBalance,
  openingBalance: state.reports.openingBalance,
  totalDebitCreditAmount: state.reports.totalDebitCreditAmount,
  businessAddressList: state.clientSettings.businessAddressList,

});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllTypesLedgerListAction: (data: GetAllLedgersListPayloadType) =>
    dispatch(getAllTypesWithTaxListAction(data)),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchResetAllLeagerList: () => dispatch(resetAllTypesLedgerListWithTaxList()),
  dispatchResetResetClientSettingSuccess: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchResetReportsErrorAction: () => dispatch(resetReportsError()),
  dispatchResetReportsSuccessAction: () => dispatch(resetReportsSuccess()),
  dispatchResetLedgerStatement: () => dispatch(resetLedgerStatement()),
  dispatchGetLedgerStatement: (data: GetLedgerStatementType) =>
    dispatch(getLedgerStatementAction(data)),
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => dispatch(getSingleCustomerSupplierAction(data)),
  dispatchResetSingleCustomerSupplier: () =>
    dispatch(resetSingleCustomerSupplier()),
  dispatchResetTaxLedgerStatementCount: () =>
    dispatch(resetTaxLedgerStatementCount()),
  dispatchResetReportsFetchingAction: () => dispatch(resetReportsFetching()),
  dispatchGetAllBusinessAddressList: (
    data: GetAllBussinessAddressesListPayloadType
  ) => dispatch(getAllBusinessAddressAction(data)),
  dispatchResetBusinessAddressList: () => dispatch(resetBusinessAddressList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LedgerStatement);
